import { Box, Button, Divider, Grid, Stack, Typography } from '@mui/material'
import { Download } from 'lucide-react'
import { formatFileURL } from '../../utils/helper/appHelpers'

export default function ItemInfo({ item, index = 0, status }) {
    const handleDownload = () => {
        const fileUrl = formatFileURL(item?.fileInfo?.url)
        const link = document.createElement('a')
        link.href = fileUrl
        link.target = '_blank'
        link.download = item?.fileInfo?.name || `File${index + 1}`
        link.click()
    }

    return (
        <>
            <Grid container spacing={2} alignItems="center">
                {/* File Preview */}
                {/* <Grid item md={2}>
                    <Box
                        component="img"
                        src={formatFileURL(item?.fileInfo?.url)}
                        alt={item?.fileInfo?.name}
                        sx={{
                            maxWidth: '100%',
                            borderRadius: 1,
                            maxHeight: 150,
                            objectFit: 'cover',
                            border: '1px solid #eee'
                        }}
                    />
                </Grid> */}

                {/* File Info */}
                <Grid item md={9}>
                    <Typography variant="subtitle2">
                        {item?.fileInfo?.name}
                    </Typography>
                    <Stack direction="column" spacing={0.5} mt={0.5}>
                        <Typography variant="subtitle2">
                            Pages → {item?.pages}
                        </Typography>
                        <Typography variant="subtitle2">
                            Copy → {item?.quantity}
                        </Typography>


                        <Typography variant="subtitle2">
                            Paper Size → {item?.printPriceInfo?.priceJson?.paperSize}
                        </Typography>

                        <Typography variant="subtitle2">
                            Paper Type → {item?.printPriceInfo?.priceJson?.paperType}
                        </Typography>

                        <Typography variant="subtitle2">
                            Print Side → {item?.printPriceInfo?.priceJson?.printSide}
                        </Typography>

                        <Typography variant="subtitle2">
                            Printing Color → {item?.printPriceInfo?.priceJson?.printingColor}
                        </Typography>
                    </Stack>
                  
                   {/* <Stack flexDirection="row" gap={0.5} mt={0.5} flexWrap="wrap">
                        <Typography variant="subtitle2">{item?.quantity} page,</Typography>
                        <Typography variant="subtitle2">{item?.printPriceInfo?.printColor},</Typography>
                        <Typography variant="subtitle2">{item?.printPriceInfo?.printOriantation},</Typography>
                        <Typography variant="subtitle2">{item?.printPriceInfo?.priceJson?.paperSize},</Typography>
                        <Typography variant="subtitle2">{item?.printPriceInfo?.priceJson?.paperType},</Typography>
                        <Typography variant="subtitle2">{item?.printPriceInfo?.priceJson?.pricePerPage},</Typography>
                        <Typography variant="subtitle2">{item?.printPriceInfo?.priceJson?.urgentCharge},</Typography>
                        <Typography variant="subtitle2">{item?.printPriceInfo?.priceJson?.printSide},</Typography>
                        <Typography variant="subtitle2">{item?.printPriceInfo?.priceJson?.printingColor}</Typography>
                    </Stack> */}

                </Grid>
      
                {/* Price & Download */}
                <Grid item md={3}>
                    <Stack alignItems="flex-end" spacing={1}>
                        {/* {Number(item?.priceInfo?.urgentCharges || 0) > 0 ? (<span className="badge badge-success"> Express </span>) : (<span className="badge badge-warning text-dark">Standard</span>)} */}
                        {/* Download Button in Right Corner */}
                        {Number(item?.urgentCharges ?? 0) > 0 ? (
                            <span className="badge badge-success">Express</span>
                            ) : (
                            <span className="badge badge-warning text-dark">Standard</span>
                        )}

                        
                        {status !== "COMPLETED" && (
                        <Button
                            className="btn-primary btn"
                            size="small"
                            variant="contained"
                            color="primary"
                            startIcon={<Download size={16} />}
                            onClick={handleDownload}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 500,
                                borderRadius: 2,
                                px: 2.5,
                                py: 0.6,
                                alignSelf: 'flex-end',
                                background: 'linear-gradient(90deg, #1976d2 0%, #1565c0 100%)',
                                boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                                '&:hover': {
                                    background: 'linear-gradient(90deg, #1565c0 0%, #0d47a1 100%)',
                                    boxShadow: '0px 4px 6px rgba(0,0,0,0.15)',
                                },
                            }}
                        >
                            Download
                        </Button>
                        )}

                        {/* Price below the button */}
                        {/* <Typography
                            variant="subtitle1"
                            sx={{ textAlign: 'right', fontWeight: 600 }}
                        >
                            ${item?.totalPrice}
                        </Typography> */}
                    </Stack>
                </Grid>
            </Grid>

            <Divider sx={{ my: 1 }} />
        </>
    )
}
